// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__G235v","modal":"Modal_modal__rPrIC","modal__close":"Modal_modal__close__ngLGC"};